<app-card [titleKey]="translationKey + 'cardTitle'">
  <div class="row flex-between-center">
    <div class="col-12 col-sm-6 col-lg-3 my-2">
      <labeled-content [label]="translationKey + 'poFullName'">
        <label class="data-labels">{{
          projectDetails().projectOwner.name
        }}</label>
      </labeled-content>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 my-2">
      <labeled-content [label]="'general.legalForm'">
        <label class="data-labels">{{
          projectDetails().projectOwner.companyType.description
            ?? projectDetails().projectOwner.companyType.code
        }}</label>
      </labeled-content>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 my-2">
      <labeled-content [label]="'general.ownershipStructure'">
        <label class="data-labels">{{
          projectDetails().ownershipStructure
            | baseEnumItemById
              : "generic.ownershipStructure"
              : genericStore.ownershipStructureEntities()
            | translate
        }}</label>
      </labeled-content>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 my-2">
      <labeled-content [label]="translationKey + 'poTitle'">
        <label class="data-labels">{{ getProjectLeaderNameTitle() }}</label>
      </labeled-content>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 my-2">
      <labeled-content [label]="'general.contactEmail'">
        <label class="data-labels">{{
          projectDetails().projectOwner.email
        }}</label>
      </labeled-content>
    </div>
  </div>
  <hr />
  <div>
    <label class="sub-header">{{
      translationKey + "projectOwnerinfo" | translate
    }}</label>
  </div>
  @for (person of projectDetails().personsSectionA; track $index) {
    <div class="row flex-between-center">
      <div class="col-12 col-sm-6 col-lg-4 my-2">
        <labeled-content [label]="getPersonNameLabel(person)">
          <label class="data-labels">{{ getNameTitle(person) }}</label>
        </labeled-content>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 my-2">
        <labeled-content [label]="getPersonTitleLabel(person)">
          <label class="data-labels">{{ person.position ?? ' - ' }}</label>
        </labeled-content>
      </div>
    </div>
  }
  <div class="row flex-between-center">
    <div class="col-12 col-lg-4 my-2">
      <labeled-content [label]="translationKey + 'poActivities'">
        <label class="data-labels">{{
          projectDetails().teaorNumbers ?? ' - '
        }}</label>
      </labeled-content>
    </div>
  </div>
  <hr />
  <div>
    <label class="sub-header">{{
      translationKey + "poLastFinancialReports" | translate
    }}</label>
  </div>

  <app-downloadable-file-list [files]="projectDetails().filesSectionA" />

  <hr />
  <div id="project-description">
    <label class="sub-header">{{
      translationKey + "projectDescriptionAndGoal" | translate
    }}</label>
  </div>
  <div class="col-auto my-2">
    <div class="text-box">
      <p>
        {{ projectDetails().description }}
      </p>
    </div>
  </div>
</app-card>

<ng-template #person let-data>
  <div class="row flex-between-center">
    <div class="col-auto my-2">
      <labeled-content [label]="translationKey + 'poAdministrativeName'">
        <label class="data-labels">{{ "DataPlaceholder" }}</label>
      </labeled-content>
    </div>
    <div class="col-auto my-2">
      <labeled-content [label]="translationKey + 'poAdministrativeTitle'">
        <label class="data-labels">{{ "DataPlaceholder" }}</label>
      </labeled-content>
    </div>
    <div class="col-auto my-2">
      <labeled-content [label]="translationKey + 'poProfilerName'">
        <label class="data-labels">{{ "DataPlaceholder" }}</label>
      </labeled-content>
    </div>
    <div class="col-auto my-2">
      <labeled-content [label]="translationKey + 'poProfilerTitle'">
        <label class="data-labels">{{ "DataPlaceholder" }}</label>
      </labeled-content>
    </div>
    <div class="col-auto my-2">
      <labeled-content [label]="translationKey + 'poActivities'">
        <label class="data-labels">{{ "DataPlaceholder" }}</label>
      </labeled-content>
    </div>
  </div>
</ng-template>
